
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/heic-to-png-converter",
      function () {
        return require("private-next-pages/heic-to-png-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/heic-to-png-converter"])
      });
    }
  